// @ts-nocheck
/* eslint-disable */
export const alertCircleIcon = {
    data: `<svg viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="14.0265" cy="13" rx="12.0265" ry="11.5" stroke="currentColor" stroke-width="3"/><path d="M14 14V7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="14" cy="18" r="1" fill="currentColor"/></svg>`,
    name: 'alert-circle' as const
};